import React from 'react'

/**
 * Determine if this is the component's first render cycle.
 */
export function useIsFirstRender() {
  const initialized = React.useRef(false)
  // eslint-disable-next-line react-hooks/refs
  const isFirstCall = !initialized.current
  // eslint-disable-next-line react-hooks/refs
  if (isFirstCall) initialized.current = true
  return isFirstCall // eslint-disable-line react-hooks/refs
}
